export const tooltipWrapper = {
    left: 0,
    position: 'absolute',
    top: 0,
}

export const tooltip = {
    '&::after': {
        border: '10px solid transparent',
        borderTopColor: '$tooltip',
        bottom: 0,
        content: '',
        height: 0,
        left: '50%',
        position: 'absolute',
        transform: 'translate(-50%, 20px)',
        width: 0,
    },
    'background': '$tooltip',
    'borderRadius': '10px',
    'color': '$tooltipText',
    'display': 'block',
    'fontSize': '$tooltip',
    'marginLeft': '0',
    'marginTop': '-10px',
    'opacity': 0.9,
    'padding': '$tooltipVertical $tooltipHorizontal ',
    'pointerEvents': 'none',
    'position': 'absolute',
    'zIndex': '$tooltip',
    // eslint-disable-next-line sort-keys
    'variants': {
        position: {
            right: {
                '&::after': {
                    borderRightColor: '$tooltip',
                    borderTopColor: 'transparent',
                    left: '-16px',
                    top: '50%',
                    transform: 'translate(0, -50%)',
                },
                'marginLeft': '10px',
                'marginTop': 0,
            },
            top: {},
        },
    },
}
